<template>
  <a
     v-if="!signState"
     href="#"
     @click="saveURLandAuth">Log In</a>
  <a
     v-else
     href="#"
     @click="logout">Log Out</a>
</template>

<style scoped>
</style>

<script>
import querystring from "query-string";

const generateState = (length = 40) => {
  const validChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  array = array.map(x => validChars.charCodeAt(x % validChars.length));
  const randomState = String.fromCharCode.apply(null, array);
  return randomState;
};

export default {
  name: "CUHKSZOAuth",
  data () {
    return {
      client_id: process.env.VUE_APP_CUHKSZ_CLIENT_ID,
      scope: "identity", // Grants access to read a user's profile data.
      state: generateState(32),
      getCodeURL: `${process.env.VUE_APP_CUHKSZ_BASE_URI}v2/oauth/authorize`,
      getAccessTokenURL: "oauth/cuhksz/access_token",
      getUserURL: "user/info",
      refreshTokenURL: "user/refresh_token",
      callbackURL: `${process.env.VUE_APP_FRONTEND_BASE_URI}callback`,
      redirectURL: null,
      code: null,
      accessToken: null,
      signState: false
    };
  },
  computed: {
    formatCodeURL () {
      return `${this.getCodeURL}?${querystring.stringify({
        client_id: this.client_id,
        scope: this.scope,
        state: this.state,
        response_type: "code"
      })}&redirect_uri=${this.callbackURL}`;
    }
  },
  mounted () {
    this.getCode();
    if (this.code) {
      console.info("Parsed code. ");
      this.getAccessToken();
    } else {
      console.log("Trying to get user...");
      this.accessToken = localStorage.getItem("accessToken");
      if (this.accessToken !== null && typeof this.accessToken !== undefined)
        this.getUser();
    }
    if (
      !(
        window.location.pathname === "/login" ||
        sessionStorage.getItem("user") ||
        localStorage.getItem("accessToken") ||
        this.code ||
        this.accessToken
      )
    ) {
      console.info(
        "Redirecting...",
        window.location.pathname === "/login",
        sessionStorage.getItem("user"),
        localStorage.getItem("accessToken"),
        this.code,
        this.accessToken
      );
      sessionStorage.setItem("redirectURL", window.location.href, 1);
      window.location = "/login";
    }
    console.info("Nothing to do.");
  },
  methods: {
    saveURLandAuth () {
      if (
        querystring.parse(window.location.search).state !==
        sessionStorage.getItem("oauthState")
      ) {
        console.info("Navigating to oauth page. State:", this.state);
        sessionStorage.setItem("oauthState", this.state);
        console.info(
          "State should be saved in session.",
          sessionStorage.getItem("oauthState")
        );
        window.location.href = this.formatCodeURL;
      }
    },
    logout () {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("setupTime");
      localStorage.removeItem("userId");
      sessionStorage.removeItem("user");
      this.signState = false;
      this.$emit("logoutEvent");
      sessionStorage.setItem("redirectURL", window.location.href, 1);
      window.location = "/login";
    },
    getCode () {
      const parse = querystring.parse(window.location.search);
      console.info(
        "Trying to parse code...",
        parse,
        sessionStorage.getItem("oauthState")
      );
      if (parse.state === sessionStorage.getItem("oauthState")) {
        this.code = parse.code;
      }
    },
    getAccessToken () {

      localStorage.removeItem("accessToken");
      toastr.success("Logging in...");
      this.request
        .get(this.getAccessTokenURL, {
          params: {
            code: this.code,
            state: sessionStorage.getItem("oauthState")
          }
        })
        .then(response => {
          localStorage.setItem("accessToken", response.data.token);
          localStorage.setItem("setupTime", new Date().getTime());

          this.redirectURL = sessionStorage.get("redirectURL");
          this.getUser()
            .then(() => {
              const redirectURL = sessionStorage.get("redirectURL");
              if (redirectURL) {
                sessionStorage.removeItem("redirectURL");
                window.location.href = redirectURL;
              } else {
                window.location.href = "/";
              }
            })
            .catch(() => {
              window.location.href = "/login";
            });
        })
        .catch((data) => {
          console.log(data)
          window.location.href = "/";
        });
    },
    async getUser () {
      let user;
      if (sessionStorage.getItem("user")) {
        user = JSON.parse(sessionStorage.getItem("user"));
      } else {
        const hours = 14 * 24; // Reset when expries in 1 day
        const now = new Date().getTime();
        const setupTime = localStorage.getItem("setupTime");
        if (setupTime !== null && now - setupTime > hours * 60 * 60 * 1000) {
          this.refreshToken();
        }

        this.request
          .get(this.getUserURL)
          .then(response => {
            user = { ...response.data };
            sessionStorage.setItem("user", JSON.stringify(user));
            this.$emit("loginEvent", user);
            localStorage.setItem("userId", user.id);
            this.signState = true;
          })
          // invaild accessToken
          .catch(() => {
            localStorage.removeItem("accessToken");
            sessionStorage.setItem("redirectURL", window.location.href, 1);
            window.location = "/login";
          });
      }
      if (user) {
        this.signState = true;
        this.$emit("loginEvent", user);
      }
    },
    async refreshToken () {
      this.request.get(this.refreshTokenURL).then(response => {
        localStorage.setItem("accessToken", response.data.token);
        localStorage.setItem("setupTime", new Date().getTime());
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
